export function initInfiniteScroll() {
    const sentinel = document.querySelector('[data-infinite-scroll]');
    if (!sentinel) return;

    const itemsList = document.getElementById('items-list');
    const loadingEl = sentinel.querySelector('.infinite-scroll-loading');
    const loadMoreWrapEl = sentinel.querySelector('.infinite-scroll-loadmore');
    const loadMoreBtn = sentinel.querySelector('.infinite-scroll-loadmore-btn');
    const loadMoreUrl = sentinel.dataset.loadMoreUrl;
    let currentPage = parseInt(sentinel.dataset.currentPage, 10) || 1;
    let hasNextPage = sentinel.dataset.hasNextPage === '1';
    let isLoading = false;

    if (!itemsList || !loadMoreUrl || !hasNextPage) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) loadNextPage();
        });
    }, { rootMargin: '200px' });

    async function loadNextPage() {
        if (isLoading || !hasNextPage) return;
        isLoading = true;
        loadingEl.classList.remove('d-none');
        if (loadMoreBtn) loadMoreBtn.disabled = true;
        if (loadMoreWrapEl) loadMoreWrapEl.classList.add('d-none');

        try {
            const separator = loadMoreUrl.includes('?') ? '&' : '?';
            const url = `${loadMoreUrl}${separator}page=${currentPage + 1}`;
            const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!res.ok) throw new Error('Chyba při načítání dalších produktů');
            const data = await res.json();

            itemsList.insertAdjacentHTML('beforeend', data.html);
            currentPage += 1;
            hasNextPage = !!data.hasNextPage;

            if (!hasNextPage) observer.disconnect();
        } catch (e) {
            hasNextPage = false;
            observer.disconnect();
        } finally {
            isLoading = false;
            loadingEl.classList.add('d-none');
            if (loadMoreBtn) loadMoreBtn.disabled = false;
            if (loadMoreWrapEl) loadMoreWrapEl.classList.toggle('d-none', !hasNextPage);
        }
    }

    if (loadMoreBtn) loadMoreBtn.addEventListener('click', loadNextPage);

    observer.observe(sentinel);
}
